import {Button, Flex, Text} from '@priority-software/priority-style-react';
import React from 'react';
import cx from 'classnames';
import texts from '../../../ReportGenerator/texts';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

export type FooterProps = {
    componentClasses?: string;
    onCancel: () => void;
    onAddedToMenu: () => void;
    text?: string;
    disabled?: boolean;
};

export const ReportsFooter = ({
    componentClasses,
    text,
    onCancel,
    onAddedToMenu,
    disabled
}: FooterProps) => {
    return (
        <Flex
            componentClasses={cx(styles.footerContainer, componentClasses)}
            justifyContent="space-between"
            alignItems="center"
            {...createDataTestId('analytics-report-footer', true)}
        >
            <Text skin="paragraph-1" textColor="primary-700" wrap>
                {text}
            </Text>
            <Flex componentClasses={styles.buttonsContainer}>
                <Button skin="secondary" onClick={onCancel}>
                    {texts.cancel}
                </Button>
                <Button skin="primary" onClick={onAddedToMenu} disabled={disabled}>
                    {texts.addToMenu}
                </Button>
            </Flex>
        </Flex>
    );
};
